import mutations from './eprofileNemAllergia.mutations'
import actions from './eprofileNemAllergia.actions'
import getters from './eprofileNemAllergia.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
